export enum AgentAvailability{
    ONLINE = "ONLINE",
    AWAY = "AWAY",
    OFFLINE = "OFFLINE"
}